import { useCurrenciesStore } from '@btcdirect/stores';

/**
 * Get the name for a given crypto currency code
 */
export default function getCryptoCurrencyName(cryptoCurrency: string): string {
    if (!cryptoCurrency) {
        return;
    }

    const currenciesStore = useCurrenciesStore();

    return currenciesStore.getCurrencyPair(cryptoCurrency)?.baseCurrency.name ?? cryptoCurrency;
}
